<template>
  <div class="d-flex">
    <v-btn text @click="$emit('back')">{{ backLabel }}</v-btn>
    <v-btn
      color="primary"
      @click="$emit('next')"
      :disabled="disableNext"
    >
      {{ nextLabel }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'StepperActions',
  props: {
    backLabel: {
      type: String,
      default: 'Voltar'
    },
    nextLabel: {
      type: String,
      default: 'Próximo'
    },
    disableNext: {
      type: Boolean,
      default: false
    }
  }
}
</script> 